import axios from 'axios'

// Kept for backwards compat with any code that imported TOKEN_KEY; no longer written/read.
export const TOKEN_KEY = 'reqtrack_token'

const apiClient = axios.create({
  baseURL: '/api',
  withCredentials: true,
})

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

/** Extract the human-readable error message from an API response error.
 *  Falls back to err.message (the generic axios string) if no response body. */
export function getApiErrorMessage(err: Error): string {
  const axiosErr = err as { response?: { data?: { error?: string } } }
  return axiosErr.response?.data?.error ?? err.message
}

export { apiClient }
export default apiClient
